export const isVideo = string => /\.(mp4|webm|ogg|mov|flv|wmv|mkv|mpeg|mpg|m4v)$/i.test(string)
